import { defineComponent as _defineComponent } from 'vue'
import RegistrationsTable from "@/components_v3/affiliate/registrations/RegistrationsTable.vue";
import ListLayout from "@/components_v3/layout/ListLayout.vue";
import { onBeforeMount, ref } from "vue";
import { IColumnsGroup } from "@/utils/ColumnsCreator";
import { useRegistrations } from "@/services/TablePage/registrations";
import TableColumns from "@/components-UI/table/columns/TableColumns.vue";
import RegistrationsFilters from "@/components_v3/affiliate/registrations/RegistrationsFilters.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationsList',
  setup(__props) {

const { getColumns, defaultColumns } = useRegistrations();
const columns = ref<IColumnsGroup[]>([]);

onBeforeMount(() => {
    columns.value = getColumns();
});

return { __sfc: true,getColumns, defaultColumns, columns, RegistrationsTable, ListLayout, TableColumns, RegistrationsFilters }
}

})